import React, { FunctionComponent } from 'react'

import { capitalizeFirstLetter } from 'Helpers/layoutHelpers'
import { CampaignGenresProps } from './props'
import { GenresAndLanguagesRow } from './styles'

const CampaignGenresComponent: FunctionComponent<CampaignGenresProps> = ({
  genres,
}) => (
  <GenresAndLanguagesRow>
    {genres.map(
      (el, id) =>
        `${capitalizeFirstLetter(el.Genre.genre_name)}${
          id === genres.length - 1 ? '' : ', '
        }`
    )}
  </GenresAndLanguagesRow>
)

export default CampaignGenresComponent
